'use strict';

const $ = require('jquery');
const _ = require('lodash');
const lang = require('./lang');
const VideoSlide = require('./slides/video-slide');
const WelcomeSlide = require('./slides/welcome-slide');
const InstructionSlide = require('./slides/instruction-slide');
const FormSlide = require('./slides/form-slide');
const BreathalyzerSlide = require('./slides/breathalyzer-slide');
const ScanDriverLicenseSlide = require('./slides/scan-driver-license-slide');
const ControlQuestion = require('./slides/control-question-slide');
const SignSlide = require('./slides/sign-slide');
const DoneSlide = require('./slides/done-slide');
const SublocationSlide = require('./slides/sublocation-slide');
const TrackSlide = require('./slides/track-slide');
const PhotoSlide = require('./slides/photo-slide');
const SlotTimeBooking = require('./slides/slot-times-bookings');
const SMSOTPSlide = require('./slides/sms-otp-slide');

module.exports = class {
  constructor({ locationObj, photoHost, languages, fields, nameIcon, SlotTimeBookingIcon, notification }) {

    this.$container = $('#slideshow-container').html('');
    this.slides = [];
    this.previousIndex = 0;
    this.currentIndex = 0;
    this._animating = false;
    this._subLocationSlideIndexes = [];
    this._subLocationCQSlideIndexes = [];
    this._location = locationObj;
    this._photoHost = photoHost;
    this._languages = languages;
    this._fields = fields;
    this._formInstructions = this._fetchFormInstructionText();
    this._nameIcon = nameIcon;
    this._SlotTimeBookingIcon = SlotTimeBookingIcon;
    this._notification = notification;
    this._sublocation = undefined;
    this._track = undefined;
    this.hasSkipped = false;
    this.controlquesarr = [];

    // apply the data-nav-something attributes to a button or something to do navigation stuff
    this.$container.on('click', '[data-nav-next]', this.navNext.bind(this));
    this.$container.on('click', '[data-nav-previous]', this.navPrevious.bind(this));
    this.$container.on('click', '[data-nav-cancel]', this.navCancel.bind(this));
    localStorage.removeItem("unique_identification_number");
    localStorage.removeItem("luprefnr");
    localStorage.removeItem('regnr');
    localStorage.removeItem('custom_signature_value');
    this._init();
  }

  // initializes the slideshow with the static slides
  _init() {
    // redirect to slideshow on refresh
    if (performance.getEntriesByType("navigation")[0].type === 'reload') {
      var initial_url = window.location.href;
      var targeturl = initial_url.split('#');
      window.location.href = targeturl[0].replace(/\/+$/, '');
      return false;
    }
    /* Javascript in shown Kiosk website to prevent multitouch / zoom gestures */
    //disable select/mark text
    document.onmousedown = function (e) { return e.target.localName === 'input' };
    document.onselectstart = function () { return false; };

    //disable right click
    window.addEventListener("contextmenu", function (e) { e.preventDefault(); });


    var uiLabel = null;
    var show_bookings = 0;
    var show_timestamp = 0;
    var location_before_booking = 0
    var checkSMS = 0;
    this.add(new WelcomeSlide({
      languages: this._languages,
      locationId: this._location.id,
      locationIdDirectlink: btoa(this._location.id),
      currentUrl: window.location.href.indexOf("link") > -1,
      locationKiosk: this._location.module_kiosk,
      companyLogo: this._location.profile_image,
    }));

    if (this._location.unique_identifier_setting !== null) {
      uiLabel = this._location.unique_identifier_setting.unique_identifier;
      show_bookings = this._location.unique_identifier_setting.show_bookings;
      show_timestamp = this._location.unique_identifier_setting.show_timestamp;
      location_before_booking = this._location.unique_identifier_setting.location_before_booking;
    }

    if (this._location.module_sms === 1 && this._location.module_verify_otp === 1) {
      checkSMS = 1;
    }
    if (this._location.sub_locations.length !== 0){
      this.add(new SublocationSlide({ sub_locations: this._location.sub_locations }));
    }
    // ToDo: This checks if the track as a location is public, however, we should check if the track is public under location_track
    else if (this._location.tracks.some(track => track.visibility === 'public')) {
      if (this._location.module_slot_time_booking === 1 && location_before_booking === 1) {
        this.add(new TrackSlide({ tracks: this._location.tracks }));
        this.add(new SlotTimeBooking({
          locationId: this._location.id,
          unique_identifier_label: uiLabel,
          show_bookings: show_bookings,
          show_timestamp: show_timestamp
        }));
      } else if (this._location.module_slot_time_booking === 1 && location_before_booking === 0) {
        this.add(new SlotTimeBooking({
          locationId: this._location.id,
          unique_identifier_label: uiLabel,
          show_bookings: show_bookings,
          show_timestamp: show_timestamp
        }));
        this.add(new TrackSlide({ tracks: this._location.tracks }));
      }
      else{
        this.add(new TrackSlide({ tracks: this._location.tracks }));
      }
    }

    if (this._location.module_id_scan === 1) {
      this.add(new ScanDriverLicenseSlide({}));
    }
    this.add(new FormSlide({
      nameIcon: this._nameIcon,
      SlotTimeBookingIcon: this._SlotTimeBookingIcon,
      fields: this._fields,
      moduleSms: this._location.module_sms,
      uniqueIdentifierSetting: this._location.unique_identifier_setting,
      uniqueIdentifierLabel: uiLabel,
      formInstructions: this._formInstructions,
      moduleUniqueIdentifier: this._location.module_slot_time_booking,
      licensePlateRequired: this._location.license_plate_required
    }));
    this.add(new InstructionSlide({
      location: this._location,
      photoHost: this._photoHost,
      moduleUniqueIdentifier: this._location.module_slot_time_booking,
      uniqueIdentifierLabel: uiLabel,
      text: this._fetchInstructionText(),
      notification: this._notification,
      smsSlideStatus: checkSMS
    }));

    if (this._location.sub_locations.length === 0 && this._location.tracks.length === 0)
      this._generatePhotoSlides();
    if (this._location.module_control_questions == 1) {
      var settingsNumber = 0;
      if (this._location.control_questions_settings != null) {
        settingsNumber = this._location.control_questions_settings.number_of_questions;
      }

      let questions = [];
      for (let question of this._location.control_questions) {
        if (question.language.toLowerCase() === lang.locale)
          questions.push(question);
      }
      //fallback to english if no questions are found
      if (questions.length == 0) {
        for (let question of this._location.control_questions) {
          if (question.language.toLowerCase() === 'en')
            questions.push(question);
        }
      }
      questions = this.shuffle(questions);
      for (let i = 0; i < Math.min(questions.length, settingsNumber); i++) {
        this.controlquesarr.push(questions[i]);
      }

    }

    this.add(new SignSlide({
      location: this._location,
      photoHost: this._photoHost,
      moduleUniqueIdentifier: this._location.module_slot_time_booking,
      uniqueIdentifierLabel: uiLabel
    })).add(new DoneSlide({ printout: this._location.printout }));
  }

  // index is an optional parameter, when omitted the slide will be pushed onto the end of the slideshow
  add(slide, index) {
    if (typeof index === 'undefined') {
      index = this.slides.length;
      this.slides.push(slide);
    } else if (index >= 0 && index <= this.slides.length) {
      this.slides.splice(index, 0, slide);
    } else {
      console.error('index parameter out of bounds in slideshow.add call.');
    }

    let $slide = $('<section>', { 'class': 'slide' })
      .html(slide.toHtml(this.slides.length, index));
    if (index === 0) {
      this.$container.find('.active-slide').removeClass('active-slide');
      $slide.addClass('active-slide');
    }
    this.$container.append($slide);
    slide.emit('add', this, $slide);

    return this;
  }

  remove(index) {

    this.slides[index].destroy();
    this.slides.splice(index, 1);
  }

  // returns the index of the first instance of given slide type, useful for finding the form or sign slide
  // returns -1 if no slide is found
  findIndex(slideType) {
    return _.findIndex(this.slides, (slide) => slide instanceof slideType);
  }

  // NOTE: Unless you are in router.js, DO NOT USE THIS, change window.location.hash instead
  to(index) {
    if (index === 0)
      this.slides.forEach((slide) => slide.reset());

    if (index === this.currentIndex) { // do nothing
      return;
    } else if (index === this.currentIndex + 1) { // do the next
      this._next();
    } else if (typeof this.slides[index] !== 'undefined') { // teleport
      this._setCurrentIndex(parseInt(index, 10));
      this._showSlide(index);
    } else {  // die
      console.log('Slide does not exist.');
    }
  }

  // returns the id of the current sublocation
  // if current sublocation is not set, returns null
  getSublocationId() {
    if (typeof this._sublocation !== 'undefined')
      return this._sublocation.id;
    return null;
  }

  // sets the sublocation id and creates a track slide if there are tracks, otherwise generates photo slides
  setSublocation(sublocation) {
    this._sublocation = sublocation;
    this._track = undefined;
    var trackSlideIndex = 0;
    var slotTimeSlideIndex = 0;
    var subLocationSlide = '';
    var slotTimeSlide = '';
    var index = 0;
    var nextIndex = 0;
    if (this._subLocationSlideIndexes.length !== 0) {
      this._subLocationSlideIndexes.map(ind => {
        if (this.currentIndex < ind) {
          this.remove(ind);
          this._subLocationSlideIndexes.splice(this._subLocationSlideIndexes.indexOf(ind), 1);
        }
      });
    }
    slotTimeSlideIndex = this.findIndex(SlotTimeBooking);
    trackSlideIndex = this.findIndex(TrackSlide);


    if (trackSlideIndex !== -1){
      this.remove(trackSlideIndex);
    }

    if (sublocation.tracks.length === 0 && slotTimeSlideIndex !== -1) {
      this.remove(slotTimeSlideIndex);
      new SlotTimeBooking({
        locationId: sublocation.id,
        unique_identifier_label: null,
        show_bookings: 0,
        show_timestamp: 0
      });
    }

    const slotTimeBookingSlideIndex = this.findIndex(SlotTimeBooking);
    if (slotTimeBookingSlideIndex !== -1)
      this.remove(slotTimeBookingSlideIndex);

    if (sublocation.sub_locations.length !== 0) {
      subLocationSlide = new SublocationSlide({ sub_locations: sublocation.sub_locations });
      index = this.currentIndex + 1;
      this.add(subLocationSlide, index);
      this._subLocationSlideIndexes.indexOf(index) == -1 ? this._subLocationSlideIndexes.push(index) : '';
    } else if (sublocation.tracks.length === 0) {
      this._generatePhotoSlides();
    } else {
      var trackSlide = new TrackSlide({ tracks: sublocation.tracks });
      slotTimeSlide = new SlotTimeBooking({
        locationId: sublocation.id,
        unique_identifier_label: sublocation.unique_identifier_setting ? sublocation.unique_identifier_setting.unique_identifier : null,
        show_bookings: sublocation.unique_identifier_setting ? sublocation.unique_identifier_setting.show_bookings : 0,
        show_timestamp: sublocation.unique_identifier_setting ? sublocation.unique_identifier_setting.show_timestamp : 0
      });
      index = this.currentIndex + 1;
      nextIndex = this.currentIndex + 2;
      if (sublocation.unique_identifier_setting!=null && sublocation.module_slot_time_booking === 1 && sublocation.unique_identifier_setting.location_before_booking===0) {
        this.add(slotTimeSlide, index);
        this.add(trackSlide, nextIndex);
      }
      else if(sublocation.unique_identifier_setting!=null && sublocation.module_slot_time_booking === 1 && sublocation.unique_identifier_setting.location_before_booking===1) {
        this.add(trackSlide, index);
        this.add(slotTimeSlide, nextIndex);
      }
      else{
        this.add(trackSlide, index);
      }
    }
    this._getFormLables(sublocation.id);
  }

  // returns the id of the current track
  // if current track is not set, returns null
  getTrackId() {
    if (typeof this._track !== 'undefined')
      return this._track.track_location_id;
    return null;
  }

  // sets the track id and generates photo slides
  setTrack(track) {

    this._track = track;
    this._fetchFormInstructionText(track.instructions, 'track');
    this._getFormLables(track.track_location_id);
    this._generatePhotoSlides();
  }

  // return form data from the form slide in an object corresponding to the form structure and contents
  // e.g. {registration-number: '123123', freight-number: '', ...}
  getFormData() {
    const $form = this.$container.find('#form-slide form');

    if ($form.length === 0) {
      console.error('Form does not exist.');
      return {};
    }

    const ret = {};

    $form.serializeArray().forEach((field) => {
      const fieldtype = $("#" + field.name).attr('type')
      var temp = "";
      if (fieldtype == 'checkbox') {
        $.each($("#" + field.name + ":checked"), function () {
          temp += $(this).val() + ",";
        });
        temp = temp.slice(0, -1);
        ret[field.name] = temp;
      } else {
        ret[field.name] = field.value;
      }
    });

    return ret;
  }

  _next() {
    if (this._animating) return;
    let slide = this.slides[this.currentIndex + 1];
    if (typeof slide !== 'undefined') {
      this._setCurrentIndex(this.currentIndex + 1);
      this._showSlide(this.currentIndex);
    } else {
      console.log('Slide does not exist.');
    }
  }

  _setCurrentIndex(value) {
    this.previousIndex = this.currentIndex;
    this.currentIndex = value;
  }

  _showSlide(index) {
    if (typeof this.slides[index] === 'undefined') {
      console.error('Slide does not exist. Index out of bounds.');
      return;
    }

    const $previousSlide = this.$container.find('> .active-slide');
    const $nextSlide = this.slides[index].$el;
    const previousSlideAnimation = (index < this.previousIndex ? 'to-right' : 'to-left');
    const nextSlideAnimation = (index < this.previousIndex ? 'from-left' : 'from-right');

    if (this.previousIndex === index || $nextSlide.hasClass('active-slide'))
      return;

    this._animating = true;
    // move old slide out of the way (if there is an old slide)
    if ($previousSlide.length !== 0) {
      const previousSlide = this.slides[this.previousIndex];
      previousSlide.emit('beforeLeave', this);
      this.$container.find('> .active-slide')
        .on('webkitAnimationEnd oanimationend oAnimationEnd MSAnimationEnd animationend', (e) => {
          // ignore propagated animation events
          if (e.target !== e.currentTarget) return true;

          $(e.currentTarget)
            .removeClass(previousSlideAnimation)
            .off('webkitAnimationEnd oanimationend oAnimationEnd MSAnimationEnd animationend');
          previousSlide.emit('afterLeave', this);
        })
        .removeClass('active-slide')
        .addClass(previousSlideAnimation);
    }

    // move next slide into position
    const nextSlide = this.slides[index];
    nextSlide.emit('beforeEnter', this);
    $nextSlide.on('webkitAnimationEnd oanimationend oAnimationEnd MSAnimationEnd animationend', (e) => {
      // ignore propagated animation events
      if (e.target !== e.currentTarget) return true;

      $(e.currentTarget)
        .removeClass(nextSlideAnimation)
        .addClass('active-slide')
        .off('webkitAnimationEnd oanimationend oAnimationEnd MSAnimationEnd animationend');

      // if you go back and forward between two slides really fast sometimes both slides end up as active,
      // this line prevents that particular bug.
      $(e.currentTarget).siblings().removeClass('active-slide');

      nextSlide.emit('afterEnter', this);
    });
    $nextSlide.addClass(nextSlideAnimation);

    setTimeout(() => {
      this._animating = false;
    }, 750)
  }

  // creates the appropriate slide at the appropriate position
  _generatePhotoSlides() {
    // remove any pre-existing photo slides first, do it backwards because as.remove() changes the position of subsequent slides
    for (let i = this.slides.length - 1; i >= 0; i--) {
      const slide = this.slides[i];
      if (slide instanceof PhotoSlide || slide instanceof VideoSlide)
        this.remove(i);
      if (slide instanceof BreathalyzerSlide)
        this.remove(i);
    }

    // generates and insert new photo slides to the slideshow after the instruction slide (if there is one)
    const instructionSlideIndex = this.findIndex(InstructionSlide);
    let index = (instructionSlideIndex === -1 ? this.slides.length : instructionSlideIndex + 1);

    //Ajax Call to get the video and its length
    var urlbreak = window.location.href.split('?')[0];
    var urltocall = urlbreak.split("#")[0];
    var slideshowactivationflag = 'notaddvideoslide';
    let subLocationId = this.getTrackId() ? this.getTrackId() : this.getSublocationId();
    let video_response = "";
    $.ajax({
      async: false,
      type: "GET",
      url: urltocall + "/getvideo",
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: {
        subLocationId: subLocationId,
      },
      success: function (response) {
        if (response.video_name != "") {
          slideshowactivationflag = "addvideoslide";
          video_response = response;
        }
      }
    });

    //Set breathlyzer after welcome screen

    let breathalyzer = this._location.breathalyzer_freq;
    let breathalyzer_status = this._location.breathalyzer_status;
    let module_breathalyzer = this._location.module_breathalyzer;
    let breathresponse = "";
    var breathurltocall = urltocall + '/get-company-breathalyzer-data';


    let seed = Math.random();
    if (breathalyzer > 0 && module_breathalyzer > 0 && breathalyzer_status == 1 && seed < breathalyzer && $(window).width() > 700) {
      $.ajax({
        async: false,
        type: "GET",
        url: breathurltocall,
        data: {
          subLocationId: this.getSublocationId(),
        }
      }).done((response) => {
        breathresponse = response;
      });
      if (breathresponse == 'success') {
        this.add(new BreathalyzerSlide({}), index);
        localStorage.setItem("is_breathalyzer", "1");
        index = index + 1;
      }
    }

    //Set video slide after welcome screen
    if (slideshowactivationflag == "addvideoslide") {
      this.add(new VideoSlide(video_response), index);
      index = index + 1;
    }


    let previousName = '';
    const photos = this._fetchPhotos();
    photos.filter((photo) => photo.show_in_slideshow).forEach((photo) => {
      const photoText = this._fetchPhotoText(photo);
      previousName = photoText.name || previousName;
      let photoUrl = photo.url.replace(/(\.[\w\d_-]+)$/i, '_slideshow$1');
      this.add(new PhotoSlide({
        title: photoText.name || previousName,
        photoUrl: this._photoHost + photoUrl,
        text: photoText.text,
      }), index);
      index += 1;
    });
  }

  // generates an array of photos given this._sublocation and this._track
  _fetchPhotos() {
    if (!location)
      console.error('fetchPhotos() requires the location object!');

    let photos = this._location.photos.slice(); // shallow copy of location.photos
    if (typeof this._sublocation !== 'undefined')
      photos = photos.concat(this._sublocation.photos.sort((a, b) => a.order - b.order));
    if (typeof this._track !== 'undefined')
      photos = photos.concat(this._track.photos.sort((a, b) => a.order - b.order));

    return photos;
  }

  _fetchInstructionText() {
    let fallback = '';
    for (const locationText of this._location.location_texts) {
      if (locationText.language.toLowerCase() === lang.locale)
        return locationText.instructions;
      else if (locationText.language.toLowerCase() === lang.localeFallback)
        fallback = locationText.instructions;
    }
    return fallback;
  }

  _fetchFormInstructionText(instructions = null, slidetype = null) {
    this._formInstructions = '';
    if (!instructions)
      instructions = this._location.location_texts;
    let fallback = '';
    for (const locationText of instructions) {
      let form_instruction = locationText.form_instructions;
      if (locationText.language.toLowerCase() === lang.locale && form_instruction !== '') {
        this._formInstructions = form_instruction;
        return form_instruction;
      }
      else if (locationText.language.toLowerCase() === lang.localeFallback && form_instruction !== '') {
        this._formInstructions = form_instruction;
      } else if (locationText.language === this._location.default_language && form_instruction !== '' && slidetype == null) {
        this._formInstructions = form_instruction;
      }
      else {
        if (slidetype == 'sublocation' && locationText.language === this._sublocation.default_language && form_instruction != '') {
          this._formInstructions = form_instruction;
          return form_instruction;
        }

        else if (slidetype == 'track' && locationText.language === this._track.track_data.default_language && form_instruction != '') {
          this._formInstructions = form_instruction;
          return form_instruction;
        }

      }
    }
    return this._formInstructions;
  }

  _getFormInstructionText() {
    return this._formInstructions;
  }


  _fetchPhotoText(photo) {
    let fallback = { name: '', text: '' };
    let langmatch = 0;
    let langfallmatch = 0;
    let fallback_data = { name: '', text: '' };
    let defaultfallback_data = { name: '', text: '' };
    for (const photoText of photo.photo_texts) {
      if (photoText.language.toLowerCase() === lang.locale) {
        langmatch = 1;
        if (photoText.name === null || photoText.name == '') {
          let photoDefaultTextName = photo.photo_texts.filter((z) => {
            return z.language.toLowerCase() === lang.defaultLocale;
          });
          if (photoDefaultTextName.length > 0) {
            if (photoDefaultTextName[0].name === null || photoDefaultTextName[0].name == '') {
              let photoTextName = photo.photo_texts.filter((x) => {
                return x.language.toLowerCase() === lang.localeFallback;
              });
              if (photoTextName.length > 0) {
                if (photoTextName[0].name === null || photoTextName[0].name == '') {
                  photoText.name = '';
                } else {
                  photoText.name = photoTextName[0].name;
                }
              } else {
                photoText.name = '';
              }
            } else {
              photoText.name = photoDefaultTextName[0].name;
            }
          }
          else {
            let photoTextName = photo.photo_texts.filter((x) => {
              return x.language.toLowerCase() === lang.localeFallback;
            });
            if (photoTextName.length > 0) {
              if (photoTextName[0].name === null || photoTextName[0].name == '') {
                photoText.name = '';
              } else {
                photoText.name = photoTextName[0].name;
              }
            } else {
              photoText.name = '';
            }
          }

        }
        if (photoText.text === null || photoText.text == '') {
          let photoDefaultTextText = photo.photo_texts.filter((t) => {
            return t.language.toLowerCase() === lang.defaultLocale;
          });
          if (photoDefaultTextText.length > 0) {
            if (photoDefaultTextText[0].text === null || photoDefaultTextText[0].text == '') {
              let photoTextText = photo.photo_texts.filter((y) => {
                return y.language.toLowerCase() === lang.localeFallback;
              });

              if (photoTextText.length > 0) {
                if (photoTextText[0].text === null || photoTextText[0].text == '') {
                  photoText.text = '';
                }
                else {
                  photoText.text = photoTextText[0].text;
                }

              } else {
                photoText.text = '';
              }
            }
            else {
              photoText.text = photoDefaultTextText[0].text;
            }

          }
          else {
            let photoTextText = photo.photo_texts.filter((y) => {
              return y.language.toLowerCase() === lang.localeFallback;
            });

            if (photoTextText.length > 0) {
              if (photoTextText[0].text === null || photoTextText[0].text == '') {
                photoText.text = '';
              }
              else {
                photoText.text = photoTextText[0].text;
              }

            } else {
              photoText.text = '';
            }
          }

        }
        fallback = photoText;
      } else if (photoText.language.toLowerCase() === lang.defaultLocale) {
        langfallmatch = 1;
        if (photoText.name !== null && photoText.name !== '')
          defaultfallback_data.name = photoText.name;
        if (photoText.text !== null && photoText.text !== '')
          defaultfallback_data.text = photoText.text;
      } else if (photoText.language.toLowerCase() === lang.localeFallback) {
        if (photoText.name !== null && photoText.name !== '')
          fallback_data.name = photoText.name;
        if (photoText.text !== null && photoText.text !== '')
          fallback_data.text = photoText.text;
      }
    }
    if (langmatch == 0 && langfallmatch == 1) {
      fallback = defaultfallback_data;
    } else if (langmatch == 0 && langfallmatch == 0) {
      fallback = fallback_data;
    }
    return fallback;
  }

  // DOM EVENTS

  navNext(e) {
    if (e) e.preventDefault();
    if (this._animating) return;
    $("#slideshow-container").animate({ scrollTop: 0 });
    window.location.hash = '/' + (this.currentIndex + 1);
  }

  navPrevious(e) {
    if (e) e.preventDefault();
    if (this._animating) return;
    $("#slideshow-container").animate({ scrollTop: 0 });
    window.location.hash = '/' + (this.currentIndex - 1);
  }

  navCancel(e) {
    if (e) e.preventDefault();
    if (this._animating) return;
    localStorage.removeItem("unique_identification_number");
    localStorage.removeItem("luprefnr");
    localStorage.removeItem('regnr');
    localStorage.removeItem('custom_signature_value');
    $("#label_exist_code").val('0');
    let url = new URL(window.location.href);
    url.hash = '';
    window.location.href = url.toString();
  }

  /**
   * Shuffles array in place.
   * @param {Array} a items An array containing the items.
   */
  shuffle(a) {
    let j, x, i;
    for (i = a.length - 1; i > 0; i--) {
      j = Math.floor(Math.random() * (i + 1));
      x = a[i];
      a[i] = a[j];
      a[j] = x;
    }
    return a;
  }

  /**
   * get labels for a location.
   * @param location_id
   */
  _getFormLables(location_id) {
    this._fields = [];
    var res = "";
    var urlbreak = window.location.href.split('?')[0];
    var urltocall = urlbreak.split("#")[0] + '/getformfields';
    $.ajax({
      async: false,
      type: "GET",
      url: urltocall,
      contentType: "application/json; charset=utf-8",
      dataType: "json",
      data: {
        location_id: location_id,
      },
      success: function (response) {
        if (response !== '') {
          res = response;
        }
      }
    });
    if (res != '') {
      this._fields = res.data;

      $("#label_location_id").val(res.label_location_id);
    }
  }

  /*
  *
  */
  _setFormLabel() {
    return this._fields;
  }

  /**
   * Update fields value
   */

  _setCustomFieldValue(index, value) {
    this._fields[index].value = value;
  }

  _clearForm() {
    document.getElementById("form_field_id_scan").value = "";
    var fieldarr = this._setFormLabel();
    $.each(fieldarr, function (key, data) {
      data['value'] = undefined;
    });
    document.getElementById("formfieldlabelform").reset();
    $("#label_exist_code").val('0');
  }

  setControlQuestion() {
    let numberOfQuestionSlides = jQuery('.control-questions-slide').length;
    if (numberOfQuestionSlides > 0) {
      let numberOfSlides = jQuery('.slideshow-container .slide').length - 2;
      for (let i = 0; i < numberOfQuestionSlides; i++) {
        this.remove(numberOfSlides - i - 1);
      }
    }

    let questions = [];
    var settingsNumber = 0;

    if (this._location.control_questions_settings != null && this._location.control_questions_settings.number_of_questions) {
      settingsNumber = this._location.control_questions_settings.number_of_questions;
    }

    if (this._location.module_control_questions == 1) {

      if (this.controlquesarr.length !== 0) {
        $.each(this.controlquesarr, function (k, v) {
          questions.push(v);
        })
      }

      if (this._sublocation && this._sublocation.length != 0) {
        if (this._sublocation.module_control_questions == 1) {

          if (this._sublocation.control_questions_settings != null && this._sublocation.control_questions_settings.number_of_questions) {
            settingsNumber += this._sublocation.control_questions_settings.number_of_questions;
          }
          if (this._sublocation.control_questions.length !== 0) {
            var subloclangcnt = 0;
            $.each(this._sublocation.control_questions, function (k, v) {

              if (v.language.toLowerCase() === lang.locale) {
                questions.push(v);
                subloclangcnt++;
              }
            })
            if (subloclangcnt == 0) {
              $.each(this._sublocation.control_questions, function (kk, vv) {
                if (vv.language.toLowerCase() === 'en')
                  questions.push(vv);
              });
            }
          }
        }
      }

      if (this._track && this._track.length != 0) {
        if (this._track.track_data.module_control_questions == 1) {
          if (this._track.control_questions_settings != null && this._track.control_questions_settings.number_of_questions) {
            settingsNumber += this._track.control_questions_settings.number_of_questions;
          }
          if (this._track.control_questions && this._track.control_questions.length !== 0) {
            var trackloclangcnt = 0;
            $.each(this._track.control_questions, function (k, v) {
              if (v.language.toLowerCase() === lang.locale) {
                questions.push(v);
                trackloclangcnt++;
              }
            })
            if (trackloclangcnt == 0) {
              $.each(this._track.control_questions, function (kk, vv) {
                if (vv.language.toLowerCase() === 'en')
                  questions.push(vv);
              });
            }
          }
        }
      }
      questions = this.shuffle(questions);
      let totalsl = jQuery('.slideshow-container .slide').length - 2;
      for (let i = 0; i < Math.min(questions.length, settingsNumber); i++) {
        const controlqiuestionslide = new ControlQuestion({ title: lang._langData.control_questions_title, questionData: questions[i] });
        this.add(controlqiuestionslide, totalsl);
        totalsl += 1;
      }

    }
  }



  // Add SMSOTP slide based on some conditions
  addSmsOtpSlide(actionType) {
    var otpSlideIndex = this.findIndex(SMSOTPSlide);
    if (actionType == "remove") {
      if (otpSlideIndex != -1) {
        this.remove(otpSlideIndex);
      }
    }
    if (actionType == "add") {
      if (otpSlideIndex == -1) {
        let formSlideIndex = this.findIndex(FormSlide);
        let newOtpSlideIndex = parseInt(formSlideIndex) + 1;
        this.add(new SMSOTPSlide({}), newOtpSlideIndex);
      }
    }
  }
  //SMSOTP slide based on some conditions completed

  //Convert Month Digit to Month Name MMM
  getMonthName(monthNumber) {
    const date = new Date();
    date.setMonth(monthNumber - 1);

    return date.toLocaleString('en-US', {
      month: 'short',
    });
  }
  //End of Convert month name


};